import { whyUs } from "@/mocks/site/content";

export default function WhyUsSection() {
  return (
    <section className="py-20 md:py-28 bg-[#FAF5EC]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mb-12">
          <div className="text-xs uppercase tracking-[0.18em] text-brand-600 font-bold mb-3">
            Why Haulmark
          </div>
          <h4 className="font-display text-3xl md:text-5xl font-bold text-ink-900 leading-tight tracking-tight">
            <a href="#why" className="text-ink-900 hover:text-ink-900 no-underline">
              The kind of movers your friends keep recommending.
            </a>
          </h4>
        </div>

        <div id="why" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {whyUs.map((item) => (
            <article
              key={item.title}
              className="bg-white rounded-xl p-6 md:p-7 border border-ink-100 hover:border-brand-300 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-brand-100 text-brand-600 mb-5">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="font-display text-lg font-bold text-ink-900 leading-tight mb-2.5">
                {item.title}
              </h3>
              <p className="text-sm text-ink-600 leading-relaxed">{item.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}